module.exports = __webpack_public_path__ + "static/media/modelagem_processo.03a564e5.md";